import styled, { css } from "styled-components";

export const Label = styled.div`
  ${({ theme }) => css`
    white-space: nowrap;
    font-size: ${p => p.small ? '12px' : '16px'};
    font-weight: ${p => p.small ? '600' : '400'};
    color: ${theme?.colour?.secondary ?? "#04333b"};
  `}
`;